export default __webpack_public_path__ + "static/media/ico_diagnostics.a2eac2a2.svg";